<template>
  <div class="head-top">
    <div class="logo"><img src="../../assets/img/header/Logo.png" alt=""></div>
    <div class="search" @click="toSearchPage"><span>请输入品牌，车型</span></div>
    <div class="city" @click="toCityPage"><span>{{headData.cityName}}</span></div>
    <div class="open-app" @click="openApp()"></div>
    <div class="usercenter" @click="openUserCenter"></div>
  </div>
</template>
<script>
  export default {
    name: "HeadBar",
    props:{
      headData: Object
    },
    methods:{
      /*去搜索页*/
      toSearchPage(){
        console.log('搜索')
        this.headData.searchUrl && (window.location.href = this.headData.searchUrl)
      },
      /*去城市页*/
      toCityPage(){
        this.cityInfo.goToCityPage(1) // 请求城市的类型 1=>已点亮城市 -1=>已开通城市  空=>全部城市
      },
      /*打开App*/
      openApp(){
        console.log('打开App')
        if (this.browser.versions.ios) {
          window.location.href = "tuanche://home";
          setTimeout(function(){
            //ios系统第一次window.location.href尝试打开app有时候会弹一下是否在某款app中打开之后马上跳到商店，为了解决这个问题我加了两遍window.location.href
            window.location.href = "itms-apps://itunes.apple.com/cn/app/%E5%9B%A2%E8%BD%A6-%E4%B8%AD%E5%9B%BD%E9%A2%86%E5%85%88%E7%9A%84%E6%B1%BD%E8%BD%A6%E7%94%B5%E5%95%86%E5%B9%B3%E5%8F%B0/id907026289?mt=8";
            window.location.href = "itms-apps://itunes.apple.com/cn/app/%E5%9B%A2%E8%BD%A6-%E4%B8%AD%E5%9B%BD%E9%A2%86%E5%85%88%E7%9A%84%E6%B1%BD%E8%BD%A6%E7%94%B5%E5%95%86%E5%B9%B3%E5%8F%B0/id907026289?mt=8";
          },1000)
        }else if (this.browser.versions.android){
          window.location.href = "tuanche://";
          setTimeout(function(){
            window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.tuanche.app";
          },1000)
        }
      },
      /*打开用户中心*/
      openUserCenter(){
        // if(!this.cookie.getCookie("token")){
          this.headData.usersUrl && (window.location.href = this.headData.usersUrl)
        // }else {
        //   window.location.href = this.url.mTuancheCom+'usercenter'+'?homeUrl='+this.url.api.WAP_TUANCHE_COM
        // }
      }
    }
  }
</script>
<style lang="less" scoped>
  .head-top{
    width: 100%;
    height: 100px;
    padding: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    .logo{
      width: 92px;
      height: 60px;
    }
    .search{
      width: 306px;
      height: 64px;
      background: url("../../assets/img/header/search_bg.png");
      background-size: 100% 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
      color: #C6C6C6;
      font-size: 24px;
      box-sizing: border-box;
      &:after{
        width: 33px;
        height: 33px;
        display: inline-block;
        content: '';
        background: url("../../assets/img/header/search.png") no-repeat;
        background-size: cover;
      }
    }
    .city{
      display: flex;
      align-items: center;
      font-size: 28px;
      color: #333333;
      text-align: center;
      &:after{
        display: inline-block;
        content: '';
        width: 13px;
        height: 8px;
        margin-left: 8px;
        background: url("../../assets/img/header/down_arrow.png");
        background-size: cover;
      }
      span {
        width: 1.6rem;
        padding-left: 0.1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .open-app{
      width: 50px;
      height: 50px;
      background: url("../../assets/img/header/app.png");
      background-size: cover;
    }
    .usercenter{
      width: 50px;
      height: 50px;
      background: url("../../assets/img/header/users.png");
      background-size: cover;
    }
    img{
      width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/header/HeadBar.vue